import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { dictionary } from '../../dictionary';

export const contactActions = [
  {
    label: dictionary.general.phone,
    href: `tel:${dictionary.general.phone}`,
    icon: <CallOutlinedIcon />,
  },
  {
    label: dictionary.general.floatingCta.whatsapp,
    href: `https://wa.me/${dictionary.general.whatsapp}`,
    icon: <WhatsAppIcon />,
    external: true,
  },
  {
    label: dictionary.general.address,
    href: dictionary.general.waze,
    icon: <FmdGoodOutlinedIcon />,
    external: true,
  },
  {
    label: dictionary.general.email,
    href: `mailto:${dictionary.general.email}`,
    icon: <EmailOutlinedIcon />,
  },
];
